export const ArtworksHelper = {
  DUBBING_TYPES: [
    {
      value: 'AUCUN',
      label: 'AUCUN',
    },
    {
      value: 'HUMAIN (fourni par ayant-droit)',
      label: 'HUMAIN (fourni par ayant-droit)',
    },
    {
      value: 'AYANT-DROIT + CMS',
      label: 'AYANT-DROIT + CMS',
    },
    {
      value: 'VERSION CMS',
      label: 'VERSION CMS',
    },
    {
      value: 'IA – OLLANG',
      label: 'IA – OLLANG',
    },
    {
      value: 'IA – RASK',
      label: 'IA – RASK',
    },
  ],
}
